import React from "react";

export default function Section5() {
  return (
    <div className="Section5 bg-[#DA2128] w-[80%] mx-auto px-5 my-[4%] md:my-0 md:p-[2%] md:flex justify-evenly items-center md:mb-[4%]">
      <div className="w-[60%]">
        <h2 className="text-white text-[24px] leading-[26px] md:text-[34px] pt-[7%] md:pt-0 md:leading-[40px] font-bold mb-[10px] mt-5">
          Leverage E-Commerce AI
        </h2>

        <p className="text-[16px] leading-[20px] text-white">
          Let’s talk about solutions to accelerate your AI systems and boost
          your e-commerce business
        </p>

        <a
          href="https://mean3.com/contact-mean3/"
          className="text-[#DA2128] px-[10px] xs:px-[30px] mt-[10px] xl:px-0 py-[10px] block leading-[1.15] font-bold bg-white w-[60%] xl:w-[40%] text-center"
        >
          Talk To Our AI Expert
        </a>
      </div>

      <div>
        <img
          className="mx-auto w-[80%] md:w-auto"
          src="../../../assets/leverage-ai-in-ecommerce.png"
        ></img>
      </div>
    </div>
  );
}
